import { render, staticRenderFns } from "./AdminSuperPrograms.vue?vue&type=template&id=23f85376&scoped=true&lang=pug&"
import script from "./AdminSuperPrograms.vue?vue&type=script&lang=js&"
export * from "./AdminSuperPrograms.vue?vue&type=script&lang=js&"
import style0 from "./AdminSuperPrograms.vue?vue&type=style&index=0&id=23f85376&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f85376",
  null
  
)

export default component.exports